module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/backArrow-03263a9fb2f1fd7f08f062823e9e1127.png";